<template>
  <div>{{ content.length }} {{ $i18n.t('subform_field_record_amount') }}</div>
</template>

<script>
export default {
  name: 'SubFormField',
  props: {
    content: {
      type: Array,
    },
  },
}
</script>
